import { match } from '../utilities/ResolutionHandler';
import BaseComponent from '../abstracts/BaseComponent';

export default class DropdownComponent extends BaseComponent {
  get Messages() {
    return {
      [this.CUSTOM_MESSAGES.DROPDOWN_EVENTS.hide]: this.close
    };
  }

  get SELECTORS() {
    return {
      panel: this.$options.panel || '.js-dropdown-panel',
      trigger: this.$options.trigger || '.js-dropdown-trigger',
      inputInside: '.floatl__label'
    };
  }

  get PARENT() {
    return this.$el.closest('.js-dropdown-container');
  }

  get IS_OPEN() {
    return (this.PARENT || this.$el.parentElement).classList.contains(this.CLASSES.open);
  }

  constructor(element) {
    super(element);

    this.timeout = null;

    this.bindEvents();
  }

  get CLASSES() {
    return {
      open: 'open',
      animate: 'animate',
      active: 'active',
      dot: 'dot',
      noScrollBody: 'no-scroll-body'
    };
  }

  /**
   *
   * @param {String} content - Panel content
   * @param {Array} [parentClasses = []] - Parent element classes
   * @param {Array} [panelClasses ? []] - Panel classes
   */
  open(content, parentClasses = [], panelClasses = []) {
    this.EMIT(this.CUSTOM_MESSAGES.DROPDOWN_EVENTS.open, {
      triggerSelector: this.SELECTORS.trigger
    });

    try {
      const parent = this.PARENT || this.$el.parentElement;
      const panel = parent.querySelector(this.SELECTORS.panel);

      parent.classList.add(this.CLASSES.open);

      if (parent.classList.contains(this.CLASSES.noScrollBody)) {
        const body = document.querySelector('body');
        body.classList.add(this.CLASSES.noScrollBody);
      }

      this.timeout = setTimeout(
          () => {
            if (content) {
              panel.innerHTML = content;
            }

            if (parentClasses) {
              this.parentClasses = parentClasses;
              parent.classList.add(...parentClasses);
            }

            if (panelClasses) {
              this.parentClasses = parentClasses;
              panel.classList.add(...panelClasses);
            }

            if (this.$options.ispreheader) {
              this.$el.closest('.pre-header').classList.add('open-lang');
            }

            this.$el.classList.add(this.CLASSES.active);
            parent.classList.add(this.CLASSES.animate);
          }, 100
      );
    } catch (e) {
      console.error(e);
    }
  }

  close() {
    this.EMIT(this.CUSTOM_MESSAGES.DROPDOWN_EVENTS.close, {
      triggerSelector: this.SELECTORS.trigger
    });

    try {
      const parent = this.PARENT || this.$el.parentElement;
      const panel = parent.querySelector(this.SELECTORS.panel);
      parent.classList.remove(this.CLASSES.animate);

      if (this.parentClasses) parent.classList.remove(...this.parentClasses);
      if (this.panelClasses) panel.classList.remove(...this.panelClasses);

      if (parent.classList.contains(this.CLASSES.noScrollBody)) {
        const body = document.querySelector('body');
        body.classList.remove(this.CLASSES.noScrollBody);
      }

      if (this.$options.ispreheader) {
        this.$el.closest('.pre-header').classList.remove('open-lang');
      }

      this.timeout = setTimeout(
          () => {
            parent.classList.remove(this.CLASSES.open);
            this.$el.classList.remove(this.CLASSES.active);
          }, 100
      );
    } catch (e) {
      console.error(e);
    }
  }

  bindHover() {
    var anyFocus = false;
    if (match(null, 'medium')) {
      this.$on('mouseenter.dropdown', (e) => {
        e.preventDefault();
        clearTimeout(this.timeout);
        clearTimeout(this.closeTimeout);
        clearTimeout(this.openTimeout);
        this.openTimeout = setTimeout(() => {
          this.open();
        }, 100);
      }, this.PARENT || this.$el.parentElement);

      this.$on('mouseleave.dropdown', (e) => {
        const parent = this.PARENT || this.$el.parentElement;
        const inputInside = parent.querySelectorAll(this.SELECTORS.inputInside);
        [...inputInside].forEach((el) => {
          if (this.checkIfFocus(el)) {
            anyFocus = true;
          }
        });

        if (!anyFocus) {
          e.preventDefault();
          clearTimeout(this.timeout);
          clearTimeout(this.openTimeout);
          this.closeTimeout = setTimeout(() => {
            this.close();
          }, 100);
        } else {
          anyFocus = false;
        }
      }, this.PARENT || this.$el.parentElement);
    }
  }

  bindClick() {
    this.$on('click.dropdown', (e) => {
      if (e) {
        e.preventDefault();
      }

      clearTimeout(this.timeout);
      const isOpen = this.IS_OPEN;
      const hasCustomCss = this.$options.cssclasses !== null && this.$options.wheretoapplycss !== null;
      const elementWhereToApplyCss = document.querySelector(this.$options.wheretoapplycss);
      const parent = this.PARENT || this.$el.parentElement;

      if (isOpen) {
        this.close();
        if (hasCustomCss && elementWhereToApplyCss) elementWhereToApplyCss.classList.remove(this.$options.cssclasses);
      } else if (!parent.classList.contains('disabled')) {
        this.open();
        if (hasCustomCss && elementWhereToApplyCss) elementWhereToApplyCss.classList.add(this.$options.cssclasses);

        // PITTI20-122
        if (this.$options.closeonclick) {
          document.removeEventListener('click', this.documentClick);
          document.addEventListener('click', this.documentClick);
        }
        if (this.$options.closeonscroll) {
          window.removeEventListener('scroll', this.windowScoll);
          window.addEventListener('scroll', this.windowScoll);
        }
      }

      // PITTI20-1467
      (this.PARENT || this.$el.parentElement).dispatchEvent(new MouseEvent('click', { view: window, bubbles: true, cancelable: true }));

    }, this.$el);
  }

  bindEvents() {
    if (this.$options.handle === 'hover') {
      this.bindHover();
    }
    if (this.$options.handle === 'click') {
      this.bindClick();
    }
    if (this.$options.handle === 'all' || !this.$options.handle) {
      this.bindClick();
      this.bindHover();
    }
  }

  checkIfFocus(el) {
    return (el.form === (document.activeElement.form || null)) && (document.activeElement.localName === 'input');
  }

  documentClick = event => {
    if ((this.PARENT || this.$el.parentElement).contains(event.target)) {
      return;
    }
    this.close();
  }

  windowScoll = () => {
    this.close();
  }
}